<template>
  <v-main class="main">
    <v-container fluid class="content">
      <p class="center">当前访问的页面不存在</p>
      <div class="center">
          <v-btn class="mt-4" color="primary" @click="onClick">点击返回首页</v-btn>
      </div>
    </v-container>
  </v-main>
</template>
<script>
export default {
  name: 'NotFound',
  methods: {
    onClick() {
      this.$router.replace('/dash/')
    },
  },
}
</script>
<style lang="less" scoped>
.content {
  padding-top: 128px;
}
.center {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
}
</style>
